import type { TypographyProps } from "@mui/material";
import { Stack } from "@mui/material";
import useToggleState from "../hooks/useToggleState";
import LimitedListWithBadge from "./LimitedListWithBadge";
import ShowMoreLessButton from "./ShowMoreLessButton";

interface Props {
  title: string;
  items: string[];
  maxVisibleItems: number;
  titleTypographyProps?: TypographyProps;
  itemTypographyProps?: TypographyProps;
}

const ExpandableListWithBadge = ({
  title,
  items,
  maxVisibleItems,
  titleTypographyProps,
  itemTypographyProps,
}: Props) => {
  const [expanded, toggleExpanded] = useToggleState(false);

  return (
    <Stack spacing={0.5} sx={{ alignItems: "flex-start" }}>
      <LimitedListWithBadge
        title={title}
        items={items}
        maxVisibleItems={maxVisibleItems}
        expanded={expanded}
        titleTypographyProps={titleTypographyProps}
        itemTypographyProps={itemTypographyProps}
      />
      {items.length > maxVisibleItems && <ShowMoreLessButton expanded={expanded} onClick={() => toggleExpanded()} />}
    </Stack>
  );
};

export default ExpandableListWithBadge;
